import { IntlProvider } from 'react-intl'
import './overforTilDatabase/transferred_keys.txt'
import { useInnsynContext } from '../context/InnsynContextProvider'
import { UnTransferredMessages } from './UnTransferredMessages'
import { fallbackTexts } from './fallbackTexts'

interface Props {
    children: JSX.Element
}

const IntlProviderWrapper = ({ children }: Props) => {
    const { messages, valgtMaalform } = useInnsynContext()

    return (
        <IntlProvider
            locale={valgtMaalform || 'nb'}
            messages={{
                ...fallbackTexts.nb,
                ...UnTransferredMessages.nb,
                ...messages,
            }}>
            {children}
        </IntlProvider>
    )
}

export default IntlProviderWrapper
